var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{attrs:{"type":"info","round":"","size":"mini","color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getCode.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.txt))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }